import { render, staticRenderFns } from "./UnitSelectWord.vue?vue&type=template&id=6437a8a6&scoped=true&"
import script from "./UnitSelectWord.ts?vue&type=script&lang=ts&"
export * from "./UnitSelectWord.ts?vue&type=script&lang=ts&"
import style0 from "./UnitSelectWord.css?vue&type=style&index=0&id=6437a8a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6437a8a6",
  null
  
)

export default component.exports